module.exports = __webpack_public_path__ + "static/media/hero-2.3ce9691b.jpg";